export default "__VITE_ASSET__94d4670e__"